import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { VotingList } from '../VotingList';
import { ErrorDisplay } from '../../../../components/error-display/ErrorDisplay';
import { useStepper } from '../../../../components/steppers/common/StepperContext';
import { useStepperStepContent } from '../../../../components/steppers/common/StepperStepContentContext';
import { GqlMeeting } from '../../../../graphql/base-types.graphql';

export const GMStepVotingList = ({ meeting }: { meeting: Pick<GqlMeeting, 'id' | 'startTime'> }) => {
  const { stepNext } = useStepper();
  const { validatorStatus } = useStepperStepContent();

  return (
    <Stack gap={3}>
      <Typography level="h4">
        <Trans id="Prepare the Voting List" />
      </Typography>

      <VotingList meeting={meeting} />

      {validatorStatus?.hasError && <ErrorDisplay error={validatorStatus.error} />}

      <Box>
        <Button onClick={() => stepNext()}>
          <Trans id="Continue" />
        </Button>
      </Box>
    </Stack>
  );
};
